// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
// import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

// css
import '../stylesheets/application.scss'

// vendor
import '@fortawesome/fontawesome-free/js/fontawesome'
import 'script-loader!../src/vendor/slick'
import 'script-loader!sweetalert2/dist/sweetalert2.all'
import 'script-loader!jquery-validation'
import 'script-loader!jquery-validation/dist/localization/messages_el'
import 'script-loader!@fancyapps/ui/dist/fancybox.umd'
import 'script-loader!ez-plus/src/jquery.ez-plus'
import 'script-loader!../src/mobile-menu'
import 'script-loader!../src/search'
import 'script-loader!../src/filters'

//pages
import 'script-loader!../src/home'
import 'script-loader!../src/product'
import 'script-loader!../src/checkout'
import 'script-loader!../src/services'

Fancybox.bind(".fancybox")

$(document).on('turbolinks:load ready', function(){
    var timer               = null
    var doneTypingInterval  = 500

    init_validation();

    $("#home-search").on("keyup",function(){
        clearTimeout(timer);

        var url     = $(this).attr('url');
        var words   = $(this).val();

        timer = setTimeout(function(){
            $.ajax({
                method: 'POST',
                url: url,
                dataType: "html",
                data: { words: words },
                success: function(response){
                    $('.search-items').empty().append(response)
                }
            })
        }, doneTypingInterval);
    });

    function init_validation(){
        $('.simple_form:not(dont-validate)').validate({
            ignore: [],
            invalidHandler: function(event, validator) {
                $.each(validator.errorList, function(index, error){
                    var element              = error.element
                    var content_tabs_wrapper = $(element).closest('.content-tabs-wrapper')
                    var all_contents         = content_tabs_wrapper.find('.tab-content')
                    var element_content      = $(element).closest('.tab-content')

                    if(content_tabs_wrapper){

                        $('.tab-item > a').removeClass('active')
                        $('.tab-item[type='+element_content.attr('type')+'] > a').addClass('active')
                        if(element_content.is(":visible"))
                            all_contents.not(element_content).hide()
                        else{
                            all_contents.hide()
                            element_content.show();
                        }

                        return false;
                    }
                });
            }
        });
    }

    $('.manufacturer-slide').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
    });

    $(".main-menu-item").mouseover(function(){
        $(".sub-menu").css("visibility", "hidden")
        $(".sub-menu[type="+$(this).attr("type")+"]").css("visibility", "visible")
    })
    $("#top").mouseleave(function(){
        $(".sub-menu").css("visibility", "hidden")
    })

    $('#is-dimensions').find('.item').first().click()

    $("#t-headers .t-header").click(function(){
        $(".t-header").removeClass("active")
        $(this).addClass("active")

        $(".t-content").removeClass("active")
        $(".t-content[slug="+$(this).attr("slug")+"]").addClass("active")
    })

    $('.covid-wrapper').click(function(){
        $(".covid-message-wrapper").fadeIn("fast")
    })

    $('.close-covid').click(function(){
        $(".covid-message-wrapper").fadeOut("fast")
    })
})